import React from 'react';
import { FormattedMessage } from 'react-intl';
import Purchase from '../../lib/purchase';
import Title from '../title';

export default ({ link, description, name, merchantName }) => (
  <div className="purchase-about container">
    <div className="container">
      <Title
        text={
          <FormattedMessage
            id="purchaseDashboard.about.title"
            defaultMessage="About {name}"
            values={{ name }}
          />
        }
        bigger
      />
      { link &&
        <p>
          <span className="cool-grey">
            <FormattedMessage
              id="purchaseDashboard.about.description"
              defaultMessage="See full description at"
            />
          </span>
          {' '}
          <a target="_blank" rel="noopener noreferrer" href={link}>
            {merchantName}
          </a>
        </p>
      }
      { description && <p dangerouslySetInnerHTML={{__html: Purchase.renderProductDescription(description)}}/> }
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/about.js